import { Button, Form, Input, Modal, Radio, Select } from 'antd';
import React, { Component } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { httpPost, httpUrl } from '../../api/httpClient';
import Const from '../../const';
import '../../css/modal.scss';
import { paystoryCardCode, paystoryCardType } from '../../lib/util/codeUtil';
import { checkOverPrice, comma } from '../../lib/util/numberUtil';
import PriceInputModal from './PriceInputModal';
import image from '../../res/image';
import {modalStyle} from "../../lib/util/codeUtil";

const FormItem = Form.Item;
const { Option } = Select;

class PaystoryChargeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMode: 0,
      phoneInputModalOpen: false,
      phoneInputModalTarget: '',
      cardTypeCd: null,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    let cardInfo = {
      cardNum1: '',
      cardNum2: '',
      cardNum3: '',
      cardNum4: '',
      cardExpire1: '',
      cardExpire2: '',
      amount: '',
    };
    if (this.props.autoPay && this.props.autoPayData) {
      //자동충전인경우 현재
      if (
        this.props.autoPayData.cardNum &&
        this.props.autoPayData.cardNum.length > 12
      ) {
        cardInfo.cardNum1 = this.props.autoPayData.cardNum.substr(0, 4);
        cardInfo.cardNum2 = this.props.autoPayData.cardNum.substr(4, 4);
        cardInfo.cardNum3 = this.props.autoPayData.cardNum.substr(8, 4);
        cardInfo.cardNum4 = this.props.autoPayData.cardNum.substr(
          12,
          this.props.autoPayData.cardNum.length - 12
        );
      }
      if (
        this.props.autoPayData.validThru &&
        this.props.autoPayData.validThru.length > 3
      ) {
        cardInfo.cardExpire1 = this.props.autoPayData.validThru.substr(0, 2);
        cardInfo.cardExpire2 = this.props.autoPayData.validThru.substr(2, 4);
      }
      if (this.props.autoPayData.amount) {
        cardInfo.amount = this.props.autoPayData.amount;
      }
      if (this.props.autoPayData.bank) {
        cardInfo.cpCd = this.props.autoPayData.bank;
      }
      if (this.props.autoPayData.cardTypeCd) {
        cardInfo.cardTypeCd = this.props.autoPayData.cardTypeCd;
      }
    } else {
      //1회충전인경우 스토리지에서 불러온다
      const storageCardInfo = this.loadCardChargeInfo();
      cardInfo = Object.assign(cardInfo, storageCardInfo);
    }
    if (this.formRef.current) {
      this.formRef.current.setFieldsValue(cardInfo);
    }
  }

  loadCardChargeInfo = () => {
    const cardCharge = reactLocalStorage.getObject(
      Const.appName + '#paystoryCardCharge'
    );
    if (!cardCharge) return;
    let cardChargeObj = {};
    try {
      cardChargeObj = JSON.parse(cardCharge);
      cardChargeObj.amount = '';
      return cardChargeObj;
    } catch (e) {
      return {};
    }
  };
  onUpdateOverPrice = () => {
    const overPrice = checkOverPrice(
      this.formRef.current.getFieldValue('cardExpire1'),
      this.state.overPrice,
      this.state.overPriceSetting
    );

    this.setState({ overPrice });
  };
  openPhoneInputModal = (target) => {
    this.setState({
      phoneInputModalTarget: target,
      phoneInputModalOpen: true,
    });
  };
  charge = async () => {
    //자동충전설정
    const formData = this.formRef.current.getFieldsValue();
    const cardNo =
      formData.cardNum1 +
      formData.cardNum2 +
      formData.cardNum3 +
      formData.cardNum4;
    const expireYymm = formData.cardExpire1 + formData.cardExpire2;
    const amount = parseInt(formData.amount);
    const ordAuthNo = formData.ordAuthNo;

    if (this.props.autoPay) {
      try {
        if (amount < 50000 || amount == null) {
          Modal.info({
            title: '카드설정',
            content: <div>자동충전 금액은 50,000원 이상을 입력해야합니다.</div>,
            ...modalStyle,
            onOk() {},
          });
          return;
        }

        if (this.state.cardTypeCd === '02') {
          const NumRegExp = /^[0-9]*$/; // 숫자만 체크
          if(!NumRegExp.test(ordAuthNo) || ordAuthNo.length != 10) {
            Modal.warn({
              title: '사업자번호',
              content: '대시(-)없이 10자리 숫자를 입력해주세요',
              ...modalStyle,
              onOk() {},
            });
            return;
          }

        }
        else {
          const BirthRegExp = /([0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[1,2][0-9]|3[0,1]))/;
          if(!BirthRegExp.test(ordAuthNo) || ordAuthNo.length > 6) {
            Modal.warn({
              title: '생년월일',
              content: 'YYMMDD형태로 6자리로 입력해주세요.',
              ...modalStyle,
              onOk() {},
            });
            return;
          }
        }

        const res = await httpPost(httpUrl.issuePaystoryBillkey, [], {
          ...formData,
          cardNo,
          expireYymm,
        });
        if (res.data.resultCd === 'F011') {
          Modal.info({
            title: '설정 성공',
            content: '결제설정에 성공했습니다.',
            ...modalStyle,
          });
          this.props.getAutoCharge();

          httpPost(httpUrl.autoChargeUpdate, [], { bank: res.data.appCardCd }) // ncash_auto_charge 테이블에 BANK 컬럼을 페이스토리에서 받은 응답으로 update
              .then(result => {
                if (result.result.toUpperCase() === 'SUCCESS') {
                  //ncash_auto_charge 테이블에 BANK 컬럼을 페이스토리에서 받은 응답으로 update 되면 form 안에 cpCd도 response에 appCardCd 따라서 셋팅
                  this.formRef.current.setFieldsValue({ cpCd:  res.data.appCardCd});
                } else { }
              })
              .catch((error) => console.error(error));
        }
        else
          Modal.warn({
            title: '설정 실패',
            content: res.data.resultMsg,
            ...modalStyle,
          });
      } catch (e) {
        Modal.warn({
          title: '설정 실패',
          content: '시스템에러',
          ...modalStyle,
        });
      }
    } else {
      if (formData.amount < 10000) {
        Modal.info({
          title: '결제금액 설정',
          content: '결제금액은 10000원 이상으로 설정해주세요.',
          ...modalStyle,
        });
        return;
      }
      try {
        const res = await httpPost(httpUrl.payPaystoryBillkey, [], {
          goodsAmt: formData.amount,
        });
        if (res.data.resultCd === '3001')
          Modal.info({
            title: '결제 성공',
            content: '결제에 성공했습니다.',
            ...modalStyle,
          });
        else if (res.data.resultCd === 'BID_NOT_FOUND') {
          Modal.info({
            title: '결제 실패',
            content:
              res.data.resultMsg +
              '/ [설정] - [카드설정]에서 결제정보를 설정해주세요.',
            ...modalStyle,
          });
        } else
          Modal.warn({
            title: '결제 실패',
            content: res.data.resultMsg,
            ...modalStyle,
          });
      } catch (e) {
        Modal.warn({
          title: '결제 실패',
          content: '시스템에러',
          ...modalStyle,
        });
      }
    }
  };
  handleValuesChange = (changedValues, allValues) => {
    if (changedValues['cardTypeCd'])
      this.setState({
        cardTypeCd: changedValues['cardTypeCd'],
      });
  };

  render() {
    const { close } = this.props;
    const skinType = Const.skinType.toUpperCase();

    return (
      <React.Fragment>
        <div className="Modal-overlay" onClick={close} />
        <div className="Modal">
          <div className="charge-content-all">
            <div
              className="charge-content-title"
              onClick={() => {
                this.setState({ activeMode: 0 });
              }}>
              <div
                className={this.state.activeMode === 0 && skinType === "GOGOIT"
                    ? 'gogoit-charge-content-title-text active'
                    : this.state.activeMode === 0
                        ? 'charge-content-title-text active'
                        : 'charge-content-title-text'
                }>
                카드결제
              </div>
            </div>
            {!this.props.autoPay && (
              <div
                className="charge-content-title"
                onClick={() => {
                  this.setState({ activeMode: 1 });
                }}>
                <div
                  className={this.state.activeMode === 1 && skinType === "GOGOIT"
                      ? 'gogoit-charge-content-title-text active'
                      : this.state.activeMode === 1
                          ? 'charge-content-title-text active'
                          : 'charge-content-title-text'
                  }>
                  계좌이체
                </div>
              </div>
            )}
            <div className="close-image" onClick={close}>
              <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
            </div>

            {/* 자동결제 변경이거나 1회 카드결제 */}

            {(this.props.autoPay || this.state.activeMode === 0) && (
              <div>
                <Form
                  ref={this.formRef}
                  onFinish={this.charge}
                  onValuesChange={this.handleValuesChange}>
                  <div className="charge-element-description">
                    *{' '}
                    {this.props.autoPay
                      ? '예치금이 부족한 경우 등록된 카드로 자동 결제금액 만큼 카드사 수수료(3.3%)를 제외하고 충전됩니다.'
                      : '결제금액에서 카드사 수수료(3.3%)를 제외한 금액만큼 충전됩니다.'}
                  </div>
                  <div className="charge-element-block-content">
                    {this.props.autoPay && (
                      <>
                        {' '}
                        <div className="charge-element-block-content-field">
                          <div className="charge-element-block-content-field-text">
                            카드사 :
                          </div>
                          <div className="charge-element-block-content-field-select">
                            <FormItem
                              name="cpCd"
                              rules={[
                                {
                                  required: true,
                                  message: '카드사를 선택해주세요.',
                                },
                              ]}>
                              <Select>
                                {Object.keys(paystoryCardCode).map((key) => {
                                  return (
                                    <Select.Option value={key}>
                                      {paystoryCardCode[key]}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            </FormItem>
                          </div>
                        </div>
                        <div className="charge-element-block-content-field">
                          <div className="charge-element-block-content-field-text">
                            카드 구분 :
                          </div>
                          <div className="charge-element-block-content-field-select">
                            <FormItem
                              name="cardTypeCd"
                              rules={[
                                {
                                  required: true,
                                  message: '카드구분을 선택해주세요.',
                                },
                              ]}>
                              <Radio.Group>
                                {Object.keys(paystoryCardType).map((key) => {
                                  return (
                                    <Radio value={key}>
                                      {paystoryCardType[key]}
                                    </Radio>
                                  );
                                })}
                              </Radio.Group>
                            </FormItem>
                          </div>
                        </div>
                        <div className="charge-element-block-content-field">
                          <div className="charge-element-block-content-field-text">
                            카드번호 :
                          </div>
                          <div className="charge-element-block-content-field-text2">
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardNum1"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardNum1');
                                  }}
                                  autoComplete="off"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={4}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 4) {
                                      this.formRef.current
                                        .getFieldInstance('cardNum2')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div className="charge-element-block-content-field-divider">
                              -
                            </div>
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardNum2"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardNum2');
                                  }}
                                  autoComplete="off"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={4}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 4) {
                                      this.formRef.current
                                        .getFieldInstance('cardNum3')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div className="charge-element-block-content-field-divider">
                              -
                            </div>
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardNum3"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardNum3');
                                  }}
                                  autoComplete="off"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={4}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 4) {
                                      this.formRef.current
                                        .getFieldInstance('cardNum4')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div className="charge-element-block-content-field-divider">
                              -
                            </div>
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardNum4"
                                rules={[{ required: true, message: '미입력' }]}
                                secure="true">
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardNum4');
                                  }}
                                  autoComplete="off"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={4}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 4) {
                                      this.formRef.current
                                        .getFieldInstance('cardExpire1')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                  type="password"
                                />
                              </FormItem>
                            </div>
                          </div>
                        </div>
                        <div className="charge-element-block-content-field">
                          <div className="charge-element-block-content-field-text">
                            유효기간 :
                          </div>
                          <div className="charge-element-block-content-field-text2">
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardExpire1"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardExpire1');
                                  }}
                                  autoComplete="off"
                                  placeholder="Year"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={2}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 2) {
                                      this.formRef.current
                                        .getFieldInstance('cardExpire2')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div className="charge-element-block-content-field-divider">
                              /
                            </div>
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardExpire2"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardExpire2');
                                  }}
                                  autoComplete="off"
                                  placeholder="Month"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={2}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 2) {
                                      this.formRef.current
                                        .getFieldInstance('cardPw')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div
                              className="mobileoff"
                              style={{
                                display: 'inline-block',
                                fontSize: '14px',
                                marginLeft: '10px',
                              }}>
                              (ex, 21/05)
                            </div>
                            <div
                              className="mobile"
                              style={{
                                display: 'inline-block',
                                fontSize: '12px',
                                marginLeft: '10px',
                              }}>
                              (ex, 21/05)
                            </div>
                          </div>
                        </div>
                        <div className="charge-element-block-content-field">
                          <div className="charge-element-block-content-field-text">
                            카드 비밀번호 :
                          </div>
                          <div className="charge-element-block-content-field-text2 charge-input-price">
                            <FormItem
                              name="cardPw"
                              rules={[
                                {
                                  required: true,
                                  message: '카드 비밀번호를 입력해주세요',
                                },
                              ]}>
                              <Input
                              placeholder='앞2자리를 입력해주세요.'
                                onFocus={() => {
                                  this.openPhoneInputModal('cardPw');
                                }}
                                autoComplete="off"
                                style={{ borderRadius: '7px' }}
                                type="password"
                                onChange={(e) => {
                                  if (!e.target.value) return;
                                  if (e.target.value.length >= 2) {
                                    this.formRef.current
                                      .getFieldInstance('ordAuthNo')
                                      .focus({ cursor: 'all' });
                                  }
                                }}
                              />
                            </FormItem>
                          </div>
                        </div>
                        <div className="charge-element-block-content-field">
                          <div className="charge-element-block-content-field-text">
                            {this.state.cardTypeCd === '02'
                              ? '사업자번호'
                              : '생년월일'}{' '}
                            :
                          </div>
                          <div className="charge-element-block-content-field-text2 charge-input-price">
                            <FormItem
                              name="ordAuthNo"
                              rules={[
                                {
                                  required: true,
                                  message: `${
                                    this.state.cardTypeCd === '02'
                                      ? '사업자번호'
                                      : '생년월일'
                                  }를 입력해주세요`,
                                },
                              ]}>
                              <Input
                                onFocus={() => {
                                  this.openPhoneInputModal('ordAuthNo');
                                }}
                                autoComplete="off"
                                style={{ borderRadius: '7px' }}
                                placeholder={
                                  this.state.cardTypeCd === '02'
                                    ? '사업자번호를 - 없이 입력해주세요'
                                    : 'YYMMDD'
                                }
                                // onChange={(e) => {
                                //   if (!e.target.value) return;
                                //   if (
                                //     e.target.value.length ==
                                //     (this.state.cardTypeCd === "02" ? 10 : 6)
                                //   ) {
                                //     this.formRef.current
                                //       .getFieldInstance("amount")
                                //       .focus({ cursor: "all" });
                                //   }
                                // }}
                              />
                            </FormItem>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="charge-element-block-content-field">
                      <div className="charge-element-block-content-field-text">
                        {this.props.autoPay ? '자동 ' : ''}결제금액 :
                      </div>
                      <div className="charge-element-block-content-field-text2 charge-input-price">
                        <FormItem
                          name="amount"
                          rules={[
                            {
                              required: true,
                              message: `${
                                this.props.autoPay ? '자동 ' : ''
                              }결제할 금액을 입력해주세요`,
                            },
                          ]}>
                          <Input
                            onFocus={() => {
                              this.openPhoneInputModal('amount');
                            }}
                            autoComplete="off"
                            style={{ borderRadius: '7px' }}
                          />
                        </FormItem>
                      </div>
                    </div>
                  </div>
                  <div className="chargeKeypad">
                    <PriceInputModal
                      inline
                      diableAdd
                      isOpen={this.state.phoneInputModalOpen}
                      close={() =>
                        this.setState({ phoneInputModalOpen: false })
                      }
                      keyin={(data) => {
                        const target = this.state.phoneInputModalTarget;
                        if (!target || target === '') return;
                        const str = this.formRef.current.getFieldValue(target);
                        let value = {};
                        value[target] = str ? str + data + '' : data + '';
                        this.formRef.current.setFieldsValue(value);

                        let next = '';
                        let len = 4;
                        if (target === 'cardNum1') next = 'cardNum2';
                        if (target === 'cardNum2') next = 'cardNum3';
                        if (target === 'cardNum3') next = 'cardNum4';
                        if (target === 'cardNum4') next = 'cardExpire1';
                        if (target === 'cardExpire1') {
                          next = 'cardExpire2';
                          len = 2;
                        }
                        if (target === 'cardExpire2') {
                          next = 'amount';
                          len = 2;
                        }
                        if (target === 'amount') {
                          next = '';
                          len = 1000000;
                        }

                        if (value[target].length >= len) {
                          this.formRef.current
                            .getFieldInstance(next)
                            .focus({ cursor: 'all' });
                          this.setState({ phoneInputModalTarget: next });
                        }
                      }}
                      keyadd={(data) => {
                        let str = (
                          this.formRef.current.getFieldValue('cardExpire1') + ''
                        ).replace(/,/g, '');
                        let value = 0;
                        if (str && !isNaN(str)) value = parseInt(str);

                        this.formRef.current.setFieldsValue({
                          orderPrice: comma(value + data),
                        });
                        this.onUpdateOverPrice();
                      }}
                      backspace={() => {
                        const target = this.state.phoneInputModalTarget;
                        if (!target || target === '') return;
                        const str = this.formRef.current.getFieldValue(target);
                        let value = {};
                        value[target] = str
                          ? str.substr(0, str.length - 1)
                          : '';
                        this.formRef.current.setFieldsValue(value);
                      }}
                      reset={() => {
                        const target = this.state.phoneInputModalTarget;
                        if (!target || target === '') return;
                        let value = {};
                        value[target] = '';
                        this.formRef.current.setFieldsValue(value);
                      }}
                      ok={() => {
                        this.setState({ phoneInputModalOpen: false });
                      }}
                    />
                  </div>
                  <div className="charge-btn-wrapper">
                    <Button
                      type="primary"
                      className="charge-btn"
                      htmlType="submit">
                      {this.props.autoPay ? '저장하기' : '충전하기'}
                    </Button>
                  </div>
                </Form>
              </div>
            )}
            {this.state.activeMode === 1 && (
              <>
                {this.props.loginInfo.vaccountBank ? (
                  <>
                    <div className="charge-element-description">
                      * 아래 계좌로 입금하는 경우 이체수수료 300원을 제외하고
                      충전됩니다.
                    </div>
                    <div className="charge-element-block-content">
                      <div className="charge-element-block-content-field">
                        <div className="charge-element-block-content-field-text">
                          입금은행 :
                        </div>
                        <div className="charge-element-block-content-field-text2">
                          {this.props.loginInfo.vaccountBank.split(',')[0]}
                        </div>
                      </div>
                      <div className="charge-element-block-content-field">
                        <div className="charge-element-block-content-field-text">
                          계좌번호 :
                        </div>
                        <div className="charge-element-block-content-field-text2">
                          {this.props.loginInfo.vaccountNumber}
                        </div>
                      </div>
                      <div className="charge-element-block-content-field">
                        <div className="charge-element-block-content-field-text">
                          예금주 :
                        </div>
                        <div className="charge-element-block-content-field-text2">
                          {this.props.loginInfo.vaccountDepositor}
                        </div>
                      </div>
                    </div>
                    <div className="charge-btn-wrapper">
                      <Button
                        type="primary"
                        className="charge-btn"
                        onClick={close}>
                        확인
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="charge-element-description"
                      style={{ margin: '50px' }}>
                      * 충전용 가상계좌가 발급되지 않았습니다. 지점으로
                      문의해주세요
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default PaystoryChargeModal;
